import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, Button, NavDropdown } from "react-bootstrap";
import { Logo } from "../general/Logo";
import { LanguageSwitcher } from "../general/LanguageSwitcher";
import {
  BASE_ROUTE,
  HOME_ROUTE,
  ABOUT_ROUTE,
  SCHOOL_RESOURCES_ROUTE,
  SIGNUP_ROUTE,
  LOGIN_ROUTE,
  TEACHERS_RESOURCES_ROUTE,
  PARENTS_RESOURCES_ROUTE,
  FEATURES_ROUTE,
  PRICING_ROUTE,
} from "../../routes/RoutesPathes";
import { useTranslation } from "react-i18next";
import styles from "./Header.module.css";

export const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const collapseNav = () => {
    setExpanded(false);
  };

  // Ignore trailing slashes and letter case, so "/about/" or "/About" still match.
  // "/" and "/home" both render the Home page.
  const norm = (p) => (p || "").toLowerCase().replace(/\/+$/, "") || "/";
  const current = norm(pathname);
  const isActive = (route) => {
    const r = norm(route);
    if (r === norm(HOME_ROUTE)) return current === r || current === "/" || current === norm(BASE_ROUTE);
    return current === r || current.startsWith(r + "/");
  };
  const isResourcesActive = current.includes("/resources");

  return (
    <header>
      <Navbar
        expand="lg"
        className={`s-nav bg-white ${styles.header}`}
        fixed="top"
        expanded={expanded}
        onToggle={setExpanded}
      >
        <Container>
          <Navbar.Brand as={Link} to={HOME_ROUTE} onClick={collapseNav}>
            <Logo width="170" />
          </Navbar.Brand>

          {/* Mobile Toggle Button */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          {/* Navigation Links */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <Nav.Link as={Link} to={HOME_ROUTE} active={isActive(HOME_ROUTE)} onClick={collapseNav}>{t("pages.home")}</Nav.Link>
              <Nav.Link as={Link} to={ABOUT_ROUTE} active={isActive(ABOUT_ROUTE)} onClick={collapseNav}>{t("pages.about")}</Nav.Link>
              <Nav.Link as={Link} to={FEATURES_ROUTE} active={isActive(FEATURES_ROUTE)} onClick={collapseNav}>{t("pages.features")}</Nav.Link>
              <Nav.Link as={Link} to={PRICING_ROUTE} active={isActive(PRICING_ROUTE)} onClick={collapseNav}>{t("pages.pricing")}</Nav.Link>
              <NavDropdown
                title={t("pages.resources")}
                id="basic-nav-dropdown"
                className={isResourcesActive ? styles.dropdownActive : undefined}
              >
                <NavDropdown.Item as={Link} to={SCHOOL_RESOURCES_ROUTE} onClick={collapseNav}>{t("pages.school_resources")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to={TEACHERS_RESOURCES_ROUTE} onClick={collapseNav}>{t("pages.teachers_resources")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to={PARENTS_RESOURCES_ROUTE} onClick={collapseNav}>{t("pages.parent_resources")}</NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav className="align-items-lg-center gap-lg-2">
              <Nav.Link as={Link} to={LOGIN_ROUTE} active={isActive(LOGIN_ROUTE)} onClick={collapseNav}>{t("pages.login")}</Nav.Link>
              <Button
                as={Link}
                to={SIGNUP_ROUTE}
                onClick={collapseNav}
                variant="primary"
                className={styles.join}
              >
                {t("buttons.join_now")}
              </Button>
              <LanguageSwitcher onClick={collapseNav} />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};
